<template>
    <b-col cols="12" class="OTLandingSpace ml-2 mr-2 mt-2">
        <span class="OTWelcomeDate">
            <span>{{ showDateUser()}}</span>
        </span>
        <span></span>
        <h1 class="OTWelcomeUser">Welcome, {{this.$session.currentUser}}</h1>
    </b-col>
</template>

<script>
import moment from "moment";

export default {
    components: {},
    data() {
        return {};
    },
    methods: {
        showDateUser() {
            var pDate = moment();
            return moment(pDate).format("MMMM Do YYYY, h:mm:ss a");
        }
    },
    props: ["name"]
};
</script>

